import { render, staticRenderFns } from "./SaleItemMobile.vue?vue&type=template&id=085e7972"
import script from "./SaleItemMobile.vue?vue&type=script&lang=js"
export * from "./SaleItemMobile.vue?vue&type=script&lang=js"
import style0 from "./SaleItemMobile.vue?vue&type=style&index=0&id=085e7972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports